import { Button } from '@cbhq/cds-web/buttons';
import { VStack } from '@cbhq/cds-web/layout';
import { TextTitle1, TextTitle3 } from '@cbhq/cds-web/typography';

import { BuildQuestModal } from ':cloud/widgets/buildQuest/BuildQuestModal';
import { useBuildQuestContext } from ':cloud/widgets/buildQuest/BuildQuestProvider';

type WelcomeModalProps = {
  onRequestClose: () => void;
  visible: boolean;
};

export function WelcomeModal({ onRequestClose, visible }: WelcomeModalProps) {
  const { currentLevelColor } = useBuildQuestContext();

  return (
    <BuildQuestModal onRequestClose={onRequestClose} visible={visible} width={600}>
      <VStack width="100%" height="100%" justifyContent="space-between" alignItems="center">
        <VStack
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          spacingBottom={6}
        >
          <TextTitle1 as="h3" align="center">
            Welcome to <br />
            CDP Quest @ Devcon!
          </TextTitle1>

          <TextTitle3 as="p" spacingTop={5} spacingBottom={2} align="center">
            You have unlocked a sticker and t-shirt for playing! <br />
            Solve more challenges and claim more prizes this weekend at the Coinbase Developer
            Platform booth.
          </TextTitle3>
        </VStack>
        <VStack width="100%" justifyContent="center" alignItems="center" spacing={3}>
          <Button onPress={onRequestClose} transparent autoFocus>
            <TextTitle3 as="p" dangerouslySetColor={currentLevelColor}>
              Get started
            </TextTitle3>
          </Button>
        </VStack>
      </VStack>
    </BuildQuestModal>
  );
}
